import React, { useState } from "react";
import "./Designs_uploaded.css";
import { Form } from "react-bootstrap";
import { FormControl } from "@material-ui/core";

function Designs_uploaded({data}) {
  const [image, setImage] = useState(null);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImage(URL.createObjectURL(file));
    }
  };
  return (
    <>
      <section className="Designs_uploaded">
        <div className="content_holder">
          <div className="heading_text_holder">
            <h4>1 designs uploaded</h4>
          </div>
          <div className="text_holder">
            <p className="text_orange">Free Design Assistance </p>
            <p>
              If you have doubts about design placement, image resolution etc,
              our print support team will be happy to assist you once you have
              placed the order. You will be provided with a messaging interface
              where you can ask them any doubts about the design and print.
            </p>

            <p className="text_orange">
              Note: that this design assistance service is free of charge and
              can be used only for minor improvements or modifications.
            </p>
          </div>
        </div>

        <div className="update_img_holder">
          <label className="upload_box">
            {/* <Form.Control type="file" onChange={handleImageChange} hidden /> */}
            <div className="upload_content">
            {Array.from(data?.files).map((file, index) => (
              <img
                key={index}
                src={URL.createObjectURL(file)}
                alt={`Preview ${index + 1}`}
               className="uploaded_img"
                
              />
            ))}

              {/* {image ? (
                <img
                  src={image}
                  alt="Uploaded Preview"
                  className="uploaded_img"
                />
              ) : (
                <>
                  <img
                    src="/assets/Images/upload_icon.png"
                    alt="Upload Icon"
                    className="upload_icon"
                  />
                  <p>Uploaded Img</p>
                </>
              )} */}
            </div>
          </label>
        </div>
      </section>
    </>
  );
}

export default Designs_uploaded;
